import { callApi } from '@local_modules/generic/fetch.js'
import { fillString } from '@local_modules/generic/string-template.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'

import htmlTemplateIndex from './index.html'
import { updateView } from './data/update-view.js'
import { showSelectors } from './data/show-selectors.js'
import { activateActions } from './activate-actions.js'

import { loadChartOfAccounts } from '../../../../helpers/app-data-loaders/load-charts-of-accounts.js'
import { context } from './data/context.js'

/**
 *
 * @returns
 */
export async function showPageFinancialsWithConversionPg (params) {
  const { containerElementId, browserAppUser, browserAppAccount, statementType } = params
  console.log('showPageFinancialsWithConversionPg', statementType)

  // add allowNoAccount?: true to allow direct entity (NOT DONE)
  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.title = ['Statement:', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById(containerElementId).classList.add('position-absolute')
  document.getElementById(containerElementId).classList.add('top-to-bottom')

  const [loadedStatementLayouts, loadedChartOfAccounts] = await Promise.all([
    loadStatementLayouts(),
    loadChartOfAccounts(browserAppAccount.data.appAccount.id)
  ])

  context.browserAppAccount = browserAppAccount
  context.pgChartOfAccounts = loadedChartOfAccounts
  context.statementLayouts = loadedStatementLayouts
  context.statementType = statementType
  context.viewDecimals = 2
  context.valueBalance = statementType === 'bs' ? 'balance' : 'period'
  context.currencySymbol = 'XXX'

  showSelectors(updateView, context)

  activateActions(document.getElementById(elementId))
}

async function loadStatementLayouts () {
  const response = await callApi('/api/pg-financials/data/statement-layouts')
  return response
}
